// libs
import { css } from '@emotion/css';

import { cn } from '@lyearn/style';
import { messageItemActionOpacityStyle } from '@/features/messages/components/MessageList/style';

const ACTION_BUTTON_STYLES = 'transition opacity-0 group-hover:opacity-100';

/**
 * todo fix this
 * solved bug for ref: https://linear.app/lyearn/issue/BUG-7142/colour-of-pinned-comment-inside-community-community-is-different-from
 * removed code as it did not worked for SSR
 * */

export const pinnedStyles = css`
  background-color: #fffbebb3;
`;

export const pinnedHoverStyles = css`
  :hover {
    background-color: #fef3c799;
  }
`;

export const DESKTOP_CLASSES = {
  item: cn('relative flex px-20 py-12 group', messageItemActionOpacityStyle),
  action: cn('absolute end-8 -top-16', ACTION_BUTTON_STYLES),
  pinnedAction: cn('ms-auto flex-shrink-0', ACTION_BUTTON_STYLES),
  profile: 'ms-12',
  messageBox: 'ms-16 w-full',
  messageItem: '',
};

export const MOBILE_CLASSES = {
  item: 'relative flex px-24 py-14 group',
  action: cn('absolute end-8 -top-10', ACTION_BUTTON_STYLES),
  pinnedAction: cn('ms-auto flex-shrink-0', ACTION_BUTTON_STYLES),
  profile: 'ms-4 flex-shrink-0',
  messageBox: 'ms-0 mt-2 w-full min-w-0',
  messageItem: '',
  reactions: 'hide',
};

export const smallResponseSize = css`
  font-size: 1.4rem;
`;

export const messageInputEditStyles = css`
  max-height: unset;
`;

export const previewGridStyles = css`
  grid-template-columns: repeat(auto-fill, 40rem);
`;

const grayScaleFilter = css`
  filter: grayscale(1);
`;

export const messageBoxHiddenClasses = cn(grayScaleFilter, 'opacity-50');

export const leftMarginForUserMessageBubbles = css`
  *:has(> &) {
    margin-left: 3.6rem;
  }
`;
